export default function SideDrawerElement({
  classes,
  thumbnail,
  callback,
  inProgress,
  name = '',
}) {
  return (
    <div
      className={`sidedrawer-element ${
        inProgress
          ? 'sidedrawer-element-disabled'
          : 'sidedrawer-element-enabled'
      } ${classes}`}
      onClick={callback}
      data-cy='scene-preview'
    >
      {thumbnail ? (
        <img
          src={thumbnail}
          style={{
            height: '100%',
            width: '100%',
            borderRadius: 12,
            objectFit: 'cover',
          }}
          alt='asset'
        />
      ) : (
        <span
          style={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            display: 'inline-block',
            overflow: 'hidden',
            maxWidth: 160,
          }}
        >
          {name}
        </span>
      )}
    </div>
  );
}
